<template>
    <div>

        <div v-if="source.id"
            class="app-filters">
            <div class="app-filters__titles">
                <h4 class="app-filters__title">Driver:  {{ driver.name }}</h4>
                <p class="app-filters__instructions"> {{ driver.description }}</p>
            </div>
            <div class="app-filters__filters">
                <button
                    type="button"
                    class="element-toggle"
                    id="toggle-projects-button">
                    <span class="element-toggle__toggle"></span>
                    Show Projects
                </button>
            </div>
            <app-button
                v-show="!newVersion"
                theme="primary"
                label="Create Driver Version"
                @click="createVersion()">
            </app-button>
        </div>

        <div v-if="source.id" v-show="newVersion" class="app-modal-dialog">
            <div class="app-modal-dialog__content">
                <div class="app-modal-dialog__header">
                    <h3 class="page-main__section-title">Create Driver Version</h3>
                </div>
                <div class="app-modal-dialog__body grid">
                    <div class="col-12">
                        <div class="input inputfile">
                            <label class="inputfile__choose-file">
                                <div class="input file">
                                    <input type="file"
                                        ref="package"
                                        name="driver-file"
                                        :disabled="newVersionSaving"
                                        @change="onFileChange($event)"
                                        accept=".zip">
                                </div>
                            </label>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="input textarea">
                            <span class="label">Description</span>
                            <textarea
                                v-if="newVersion"
                                v-model="newVersion.description"
                                placeholder="What has changed in this version?"
                                :disabled="newVersionSaving"
                                name="description">
                            </textarea>
                        </div>
                    </div>
                </div>
                <div v-if="!newVersionSaving"
                    class="app-modal-dialog__footer">
                    <app-button
                        theme="secondary"
                        label="Cancel"
                        @click="newVersion = false">
                    </app-button>
                    <app-button
                        theme="primary"
                        label="Save"
                        :disabled="!newVersionRequirementsMet"
                        @click="saveNewVersion()">
                    </app-button>
                </div>
                <div v-else
                    class="app-modal-dialog__footer">
                    <span 
                        title="Processing..."
                        class="element-badge">
                        Processing, please wait...
                    </span>
                </div>
            </div>
        </div>
        <app-error
            class="mt-3"
            v-if="hasErrors && newVersion"
            v-bind="errors" />
    </div>
</template>

<script>
import api from '../api/drivers'
import DriverDashboardVersionItem from './DriverDashboardVersionItem'
import FileUploader from './FileUploader'

export default {
    components: {
        DriverDashboardVersionItem,
        FileUploader
    },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        source: {
            type: Object,
            default: () => ({
                name: '',
                description: '',
                versions: []
            })
        },
        isDefaultDriver: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            driver: _.cloneDeep(this.source),
            newVersion: false,
            newVersionSaving: false,
            errors: []
        }
    },
    computed: {
        requirementsMet () {
            return this.driver.name.length > 0
        },
        newVersionRequirementsMet () {
            return _.get(this.newVersion, 'description.length') > 0 &&
                   _.get(this.newVersion, 'package')
        },
        hasErrors () {
            return this.errors?.message
        }
    },
    methods: {
        cancel () {
            if (!this.driver.id) {
                this.$emit('cancel')
            }
        },
        async saveNewVersion () {
            this.newVersionSaving = true

            const formData = new FormData()
            formData.append('package', this.newVersion.package)
            formData.append('description', this.newVersion.description)

            // api call to save
            const result = await api.createVersion(this.driver.id, formData)
            console.log(result)

            if (result.errors) {
                // catch errors
                this.errors = result
            } else {
                this.newVersion = false
                this.$refs.package.value = ''
                this.errors = []

                window.location.reload()
            }

            this.newVersionSaving = false
        },
        createVersion () {
            this.newVersionSaving = false

            this.newVersion = {
                description: null,
                package: null
            }
        },
        getValue (name) {
            if (this.$refs[name]) {
                return this.$refs[name].textContent || this.$refs[name].innerText
            }
            return null
        },
        onFileChange (e) {
            this.newVersion.package = e.target.files[0]
        },
    },
}
</script>
